export default __webpack_public_path__ + "static/media/Shit-Splash-3.1ac09019.png";